/**
 * Whether device geometry should build at reduced (thumbnail) tessellation.
 *
 * Set by the render micro-frontend ONLY in thumbnail mode (a `?project=&scene=`
 * URL with no `renderItem`). The editor and full-size (credit-charged) renders
 * leave it false, so they always get full geometry detail. Read by `DeviceMeshV2`
 * when it builds the worker config; flows through as `WorkerInput.lowPoly`.
 */
let lowPolyThumbnail = false

export const setLowPolyThumbnail = (value: boolean) => {
  lowPolyThumbnail = value
}

export const isLowPolyThumbnail = () => lowPolyThumbnail
